import styled from "styled-components";

const StylesContainer = styled.div`
  .ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap {
    margin-left: 32px;
  }

  .ant-tabs .ant-tabs-content-holder {
    padding: 0 32px 32px;
  }

  .ant-tabs-top > .ant-tabs-nav {
    margin-bottom: 24px;
  }

  .ant-tabs .ant-tabs-tab {
    padding: 8px 8px 12px;
  }

  .ant-tabs-top > .ant-tabs-nav .ant-tabs-ink-bar {
    background: #052c2b;
    border-radius: 4px 4px 0 0;
    height: 6px;
  }

  .ant-table-wrapper .ant-table-thead > tr > th {
    background: #fff;
    font-weight: 700;

    &::before {
      display: none;
    }
  }

  .ant-table-wrapper .ant-table-thead > tr > .cell-accent,
  .ant-table-wrapper .ant-table-tbody > tr > .cell-accent {
    background: #f6f7f8;
  }

  .label-users-amount {
    background: #d5e1e2;
    border-radius: 4px;
    color: #052c2b;
    font-size: 12px;
    font-weight: 600;
    padding: 0 4px;
  }
`;

export default StylesContainer;
